import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, Typography, colors } from 'kangarootime-ui';
import Header from './Header';
import ShiftInformation from './ShiftInformation';
import ArrowLeft from '../../../../assets/svg/arrowLeft';
import ArrowRight from '../../../../assets/svg/arrowRight';
import moment from 'moment';
import './WeekOverview.css';

const WeekOverview = ({
  dates,
  shifts,
  openTimeOffRequestDialog,
  timeOff,
  changeWeek,
  showingCurrentWeek,
  selectedDate,
  onDateSelect
}) => {
  let minutesWorkedForSelectedDate = 0;
  let minutesWorkedForWeek = 0;
  const sameDate = (date1, date2) => moment(date1).isSame(moment(date2), 'date');
  const dayName = date => moment(date).format('dddd');
  const formattedDate = date => moment(date).format('MMM D');

  return (
    <Fragment>
      <div className='week-overview-container'>
        <div className='week-schedule-control-container' style={{ marginRight: 8 }} onClick={() => !showingCurrentWeek && changeWeek(-1)}>
          { !showingCurrentWeek && <ArrowLeft fill={colors.raven} /> }
        </div>
        { dates.map((date, index) => {
          const formatDateToKey = moment(date).format('YYYY-MM-DD');
          const shiftsForDate = shifts[formatDateToKey];
          const classes = classnames({
            'week-overview-date-container': true,
            'week-overview-selected-date-container': sameDate(date, selectedDate)
          });

          const rejectedTimeOff = timeOff[formatDateToKey].filter(obj => obj.status && obj.status.status === 'reject');
          const approvedTimeOff = timeOff[formatDateToKey].filter(obj => obj.status && obj.status.status === 'approve');
          const shiftsForDay = shiftsForDate ? shiftsForDate.map(shift => ({ start: shift.start, end: shift.end })) : [];
          /* eslint-disable-next-line no-return-assign */
          const totalBreakMintuesForDay = shiftsForDate ? shiftsForDate.reduce((total, current) => total += parseInt(current.breakMinutes), 0) : 0;
          /* eslint-disable-next-line no-return-assign */
          const minutesWorkedForDay = shiftsForDate ? shiftsForDay.reduce((total, current) => total += moment(current.end).diff(moment(current.start), 'minutes'), 0) : 0;

          if (sameDate(selectedDate, date)) {
            minutesWorkedForSelectedDate = (minutesWorkedForDay - totalBreakMintuesForDay);
          }

          minutesWorkedForWeek += (minutesWorkedForDay - totalBreakMintuesForDay);

          return (
            <div
              key={index}
              className={classes}
              style={{ cursor: 'pointer' }}
              onClick={event => {
                event.preventDefault();
                onDateSelect(date);
              }}
            >
              <Header label={dayName(date)} sublabel={formattedDate(date)} />
              <div key={index} className='week-overview-shifts-container'>
                <ShiftInformation
                  shifts={shiftsForDate}
                  totalBreakMintuesForDay={totalBreakMintuesForDay}
                  approvedTimeOff={approvedTimeOff}
                  rejectedTimeOff={rejectedTimeOff}
                />
              </div>
            </div>
          );
        })}
        <div className='week-schedule-control-container' onClick={() => showingCurrentWeek && changeWeek(1)}>
          { showingCurrentWeek && <ArrowRight fill={colors.raven} /> }
        </div>
      </div>
      <div className='week-overview-container' style={{ alignItems: 'center' }}>
        <div>
          <Typography type='meta'>Hours (Day): {parseFloat(minutesWorkedForSelectedDate / 60).toFixed(2)}</Typography>
          <Typography type='meta'>Hours (Week): {parseFloat(minutesWorkedForWeek / 60).toFixed(2)}</Typography>
        </div>
        <Button type='secondary' onClick={() => openTimeOffRequestDialog()}>Request time off</Button>
      </div>
    </Fragment>
  );
};

WeekOverview.propTypes = {
  dates: PropTypes.array,
  shifts: PropTypes.object,
  timeOff: PropTypes.object,
  openTimeOffRequestDialog: PropTypes.func,
  changeWeek: PropTypes.func,
  showingCurrentWeek: PropTypes.bool,
  selectedDate: PropTypes.instanceOf(Date),
  onDateSelect: PropTypes.func
};

export default WeekOverview;
